export const validationMessageError =
  'Hmm, looks like we’re missing something. Let us know how you want to apply then try again.';
